module.exports = __webpack_public_path__ + "img/1449492837.ebe55fd7.jpg";